import {ref} from "vue";
import {format} from "date-fns";

export class DateFilterHelper {
    public static filterValues = <{value:string, label:string}[]>[
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: '1week-ago', label: 'Last 7 days' },
        { value: '30days-ago', label: 'Last 30 days' },
        { value: 'current-month', label: 'Current Month' },
        { value: '1month-ago', label: 'One Month Ago' },
        { value: 'this-year', label: 'This Year' },
        { value: '1year-ago', label: 'One Year Ago' },
        { value: 'custom-range', label: 'Pick a Date'},
    ];

    public static FormatAsDateTimeString(date:Date) {
        return date.getFullYear() + "-" +
            (date.getMonth() + 1).toString().padStart(2, '0') + "-" +
            date.getDate().toString().padStart(2, '0') + " " +
            date.getHours().toString().padStart(2, '0') + ":" +
            date.getMinutes().toString().padStart(2, '0') + ":" +
            date.getSeconds().toString().padStart(2, '0');
    }

    public static FormatAsUTCDateTimeString(date: Date) {
        return date.getUTCFullYear() + "-" +
            (date.getUTCMonth() + 1).toString().padStart(2, '0') + "-" +
            date.getUTCDate().toString().padStart(2, '0') + " " +
            date.getUTCHours().toString().padStart(2, '0') + ":" +
            date.getUTCMinutes().toString().padStart(2, '0') + ":" +
            date.getUTCSeconds().toString().padStart(2, '0');
    }

    public static FormatAsDateTimeStringWithoutTimezone(date:Date) {
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        return this.FormatAsDateTimeString(date);
    }

    public static GetDateFromString(date: String) {
        return new Date(date);
    }

    public static FormatAsDateString(date:Date) {
        return date.getFullYear() + "-" +
            (date.getMonth() + 1).toString().padStart(2, '0') + "-" +
            date.getDate().toString().padStart(2, '0');
    }

    public static FormatAsRoDateString(date:Date) {
        return date.getDate().toString().padStart(2, '0') + "." +
            (date.getMonth() + 1).toString().padStart(2, '0') + "." +
            date.getFullYear();
    }

    public static FormatAsDateWithMonthString(date: Date): string {
        const months = [
            "January", "February", "March", "April", "May", "June", "July", "August",
            "September", "October", "November", "December"
        ];

        return date.getDate().toString().padStart(2, '0') + " " +
            months[date.getMonth()] + " " +
            date.getFullYear() + " " +
            date.getHours().toString().padStart(2, '0') + ":" +
            date.getMinutes().toString().padStart(2, '0');
    }

    public static FormatAsDate(date: Date) {
        if (date !==null) {
            return format(new Date(date), 'dd-MM-yyyy ')
        }
    }

    public static FormatAsDateWithHours(date: Date) {
        if (date !==null && date !== undefined) {
            return format(new Date(date), 'dd-MM-yyyy HH:mm')
        }
    }

    public static FormatAsDateWithDotsAndHours(date: Date) {
        if (date !==null && date !== undefined) {
            return format(new Date(date), 'dd.MM.yyyy HH:mm')
        }
    }

    public static filterChartValues = <{ value: string, label: string, }[]>[
        {value: '1year-ago', label: 'Last 12 month'},
        {value: '2year-ago', label: 'Last two years including current year'},
        {value: '3year-ago', label: 'Last three years including current year'},
        {value: '4year-ago', label: 'Last four years including current year'},
        {value: '5year-ago', label: 'Last five years including current year'},
        {value: 'all', label: 'All'},
    ];
    public static GetDateRange(value:string) {

        const current_date = new Date();
        const end_of_year = new Date(current_date.getFullYear(), 12, 0);
        const end_of_last_year = new Date(current_date.getFullYear() - 1, 12, 0);
        const end_of_last_month = new Date(current_date.getFullYear(), current_date.getMonth(), 0);

        let from:Date, to:Date, end_of_month:Date;

        switch (value) {
            case 'today':
                from = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate(),
                )
                to = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate(),
                )
                to.setHours(23,59,59,999)
                return {from, to};
            case 'yesterday':
                from = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate() - 1,
                )
                to = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate() - 1,
                )
                to.setHours(23,59,59,999)
                return {from, to};
            case '1week-ago':
                from = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate() - 6,
                )
                to = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate(),
                )
                to.setHours(23,59,59,999)
                return {from, to};
            case '30days-ago':
                from = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate() - 29,
                )
                to = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate(),
                )
                to.setHours(23,59,59,999)
                return {from, to};
            case 'current-month':
                from = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    1
                )
                to = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth() + 1,
                    0
                )
                to.setHours(23,59,59,999)
                return {from, to};
            case '1month-ago':
                from = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth() - 1,
                    1
                )
                to = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    0
                )
                to.setHours(23,59,59,999)
                return {from, to};
            case 'this-year':
                from = new Date(
                    current_date.getFullYear(),
                    0,
                    1,
                )
                to = new Date(
                    end_of_year.getFullYear(),
                    end_of_year.getMonth(),
                    end_of_year.getDate(),
                )
                to.setHours(23,59,59,999)
                return {from, to};
            case '1year-ago':
                from = new Date(
                    current_date.getFullYear() -1,
                    0,
                    1,
                )
                to = new Date(
                    end_of_last_year.getFullYear(),
                    end_of_last_year.getMonth(),
                    end_of_last_year.getDate(),
                )
                to.setHours(23,59,59,999)
                return {from, to};
            default:
                from = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate(),
                )
                to = new Date(
                    current_date.getFullYear(),
                    current_date.getMonth(),
                    current_date.getDate(),
                )
                to.setHours(23,59,59,999)
                return {from, to};
        }
    }
    public static GetDateRangeAsDateTimeStrings(value:string)
    {
        const range = DateFilterHelper.GetDateRange(value);

        return {
            from: DateFilterHelper.FormatAsDateTimeString(range.from),
            to: DateFilterHelper.FormatAsDateTimeString(range.to)
        }
    }
}
